import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'SPEC_DOC',
  title: 'Comment trouver un modèle d’attestation ?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous avez un doute sur un document à déposer, il vous suffit de :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cliquer sur le document de votre choix, puis cliquer sur le bouton « Cliquer pour voir un modèle du document attendu »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SPEC_DOC/FR_SPEC_DOC.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous ne retrouvez pas le modèle d’un document, n’hésitez pas à consulter les modèles sur notre page Aide et Contact.'
  }]
};
